import React, { useState, useEffect, useRef} from "react";
import { useSelector, useDispatch } from "react-redux";
import EmptyScreen from "../../component/common/EmptyScreen";
import ConfirmBox from "../../component/Popup/ConfirmBox";
import { deleteTable, openGlobalPopup } from "../../redux/action";
import TableSettingCard from "./TableSettingCard";

function TableSettingMobile({ tables, onDelete, onEdit }) {
  
  const deleteIdRef = useRef('');
  const [deleteTableId, setDeleteTableId] = useState('');
  const dispatch = useDispatch();
  const handleDelete = (restaurantTableId) => {
    console.log("handleDelete", restaurantTableId)
    deleteIdRef.current = restaurantTableId;
      //setDeleteTableId(restaurantTableId);
      console.log("Confirming Delete for:", deleteIdRef.current);
      dispatch(openGlobalPopup("confirm-box"));
  }
 

  return (
    <div className="reservation-container">

      {tables?.length === 0 ? (
        <EmptyScreen message="No tables found for this restaurant. Please add tables." />
      ) : (
        <>
          <ul className="reservation-list">
            {Array.isArray(tables) && tables?.map((req) => (
              <TableSettingCard
                res={req}
                onEdit={() => onEdit(req)}
                onDelete={() => onDelete(req.restaurantTableId)}
              />
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default TableSettingMobile;